<template>
  <div>
    <div id="vContents">
      <div id="cNav">
        <router-link tag="span" :to="{path:'/Homepage'}">首页</router-link>&nbsp;&nbsp;>>&nbsp;&nbsp;<router-link
          tag="span" :to="{path:'/about/sjactivity/activity'}">活动预约</router-link>
      </div>
      <div id="vtitle">活动预约报名表</div>
      <div id="volhr"></div>
      <div id="addvolun">
        <el-form :model="addForm" label-width="80px" :rules="addFormRules" ref="addForm">
          <el-form-item label="联系人" prop="name">
            <el-input v-model="addForm.name" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="参加人" prop="cjname">
            <el-input v-model="addForm.cjname" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="电话" prop="phone">
            <el-input v-model="addForm.phone" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="身份证号" prop="cardID">
            <el-input v-model="addForm.cardID" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="活动名称" prop="title">
            <el-input v-model="addForm.title" auto-complete="off" disabled="disabled">{{addForm.title}}</el-input>
          </el-form-item>
          <el-form-item label="备注信息" prop="info">
            <el-input v-model="addForm.info" auto-complete="off"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click.native="addSubmit" :loading="addLoading">提交</el-button>
        </div>
      </div>
      <div id="volhrbottom"></div>
      <div style="text-align: left;margin-top: 30px;color: red;">
        <P style="">特别提醒：</P>
        <p class="ql-align-justify">1、为确保活动顺利开展，预约成功的观众请于活动开始前30分钟到场，连续两次预约成功但未按时参与者,将在随后的三个月内不能参与我馆各项社教活动。</p><br />
        <p class="ql-align-justify">2、本次活动最终解释权归青海省博物馆所有。</p>
      </div>
      <div style="clear: both;"></div>
    </div>
    <div id="mvContents">
      <div id="mcNav">
        <router-link tag="span" :to="{path:'/Homepage'}">首页</router-link>&nbsp;&nbsp;>>&nbsp;&nbsp;<router-link
          tag="span" :to="{path:'/about/sjactivity/activity'}">活动预约</router-link>
      </div>
      <div id="mvtitle">活动预约报名表</div>
      <div id="mvolhr"></div>
      <div id="maddvolun">
        <el-form :model="addForm" label-width="80px" :rules="addFormRules" ref="addForm">
          <el-form-item label="联系人" prop="name">
            <el-input v-model="addForm.name" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="参加人" prop="cjname">
            <el-input v-model="addForm.cjname" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="电话" prop="phone">
            <el-input v-model="addForm.phone" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="身份证号" prop="cardID">
            <el-input v-model="addForm.cardID" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="活动名称" prop="title">
            <el-input v-model="addForm.title" auto-complete="off" disabled="disabled">{{addForm.title}}</el-input>
          </el-form-item>
          <el-form-item label="备注信息" prop="info">
            <el-input v-model="addForm.info" auto-complete="off"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click.native="addSubmit" :loading="addLoading">提交</el-button>
        </div>
      </div>
      <div id="mvolhrbottom"></div>
      <div style="text-align: left;margin-top: 30px;color: red;">
        <P style="">特别提醒：</P>
        <p class="ql-align-justify">1、为确保活动顺利开展，预约成功的观众请于活动开始前30分钟到场，连续两次预约成功但未按时参与者,将在随后的三个月内不能参与我馆各项社教活动。</p><br />
        <p class="ql-align-justify">2、本次活动最终解释权归青海省博物馆所有。</p>
      </div>
      <div style="clear: both;"></div>
    </div>
  </div>

</template>

<script>
  import qs from 'qs'
  import $ from "jquery"

  const ID_CARD_REGEXP = /^(?:\d{15}|\d{17}[\dXx])$/;

  const validateIdCard = (rule, value, callback) => {
    if (!value) {
      return callback();
    }
    if (ID_CARD_REGEXP.test(value)) {
      return callback();
    }
    callback(new Error('身份证格式不正确'));
  };
  export default {
    data() {
      return {
        loading: false,
        tableData: [],
        // 新增相关数据
        addFormVisible: true, // 新增页面是否开启
        addLoading: false,
        addForm: {
          name: '',
          cjname: '',
          cardID: '',
          title: this.$route.query.title,
          info: '',
          phone: '',
          activityid: this.$route.query.id

        },
        addFormRules: {
          name: [{
            required: true,
            message: '请输入联系人姓名',
            trigger: 'blur'
          }],
          cjname: [{
            required: true,
            message: '请输入参加人姓名',
            trigger: 'blur'
          }],
          cardID: [{
              required: true,
              message: '请输入身份证号',
              trigger: 'blur'
            },
            {
              validator: validateIdCard,
              trigger: 'blur'
            }
          ],
          title: [{
            required: true,
            message: '请输入活动名称',
            trigger: 'blur'
          }],
          info: [{
            required: true,
            message: '请输入备注信息',
            trigger: 'blur'
          }],
          phone: [{
            required: true,
            message: '请输入联系人电话',
            trigger: 'blur'
          }]
        }
      }
    },
    mounted() {
      if (this.isMobile()) {
        document.getElementById("vContents").style.display = "none";
      } else {
        document.getElementById("mvContents").style.display = "none";
        document.getElementById("vContents").style.display = "block";
      }
      if (location.href.indexOf("#reloaded") == -1) {
        location.href = location.href + "#reloaded";
        location.reload();
      };
    },
    methods: {
      isMobile() {
        let flag = navigator.userAgent.match(
          /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
        )
        return flag;
      },
      showAddDialog: function() {
        this.addForm = {
          name: '',
          cjname: '',
          cardID: '',
          title: this.$route.query.title,
          info: '',
          phone: '',
          activityid: this.$route.query.id
        }
      },
      // 新增数据
      addSubmit: function() {
        let that = this;
        let url = this.HOST + '/api/v1/activity/activityRg';
        this.$refs.addForm.validate((valid) => {
          if (valid) {
            that.loading = true;
            let para = Object.assign({}, this.addForm);
            that.$axios.post(url, para).then(function(result) {
              that.loading = false;
              if (result.data && result.data.code === 0) {
                that.$message.success({
                  showClose: true,
                  message: '活动预约报名已提交成功',
                  duration: 2000
                });
                that.$refs['addForm'].resetFields();
                that.addFormVisible = false;
                that.$router.push({
                  path: '/about/sjactivity/activity'
                });
              } else {
                that.$message.error({
                  showClose: true,
                  message: result.data && result.data.message ? result.data.message : '活动预约报名提交失败',
                  duration: 2000
                });
              }
            }, function(err) {
              that.loading = false;
              that.$message.error({
                showClose: true,
                message: err.toString(),
                duration: 2000
              });
            }).catch(function(error) {
              console.log(error)
            })
          }
        })
      }
    }
  }
</script>

<style>
  #vContents {
    display: none;
    width: 80%;
    margin: 0 10%;
  }

  #addvolun {
    width: 60%;
    margin: 10px 20%;

  }

  #volhr,
  #volhrbottom {
    width: 100%;
    height: 1px;
    border-bottom: 1px dotted #dbdbdb;
    float: left;
  }

  #vtitle {
    height: 60px;
    line-height: 60px;
  }

  .el-form-item__content {
    text-align: left;
    margin-left: 100px;
  }

  .el-radio+.el-radio {
    margin-left: 20px;
  }

  #cNav {
    text-align: left;
    height: 48px;
    line-height: 48px;
  }

  #cNav>span:nth-child(1),
  #cNav>span:nth-child(2) {
    cursor: pointer;
  }

  #cNav>span:nth-child(1):hover,
  #cNav>span:nth-child(2):hover {
    color: #FF9900;
  }

  #mvContents {
    margin: 0 10px;
  }

  #maddvolun {
    width: 100%;
  }

  #mvolhr,
  #mvolhrbottom {
    width: 100%;
    height: 1px;
    border-bottom: 1px dotted mdbdbdb;
    float: left;
  }

  #mvtitle {
    height: 60px;
    line-height: 60px;
  }

  .el-form-item__content {
    text-align: left;
    margin-left: 100px;
  }

  .el-radio+.el-radio {
    margin-left: 20px;
  }

  #mcNav {
    text-align: left;
    height: 48px;
    line-height: 48px;
  }

  #mcNav>span:nth-child(1),
  #mcNav>span:nth-child(2) {
    cursor: pointer;
  }

  #mcNav>span:nth-child(1):hover,
  #mcNav>span:nth-child(2):hover {
    color: #FF9900;
  }
</style>



// WEBPACK FOOTER //
// src/pages/about/sjactivity/acticitybm.vue